import React, { Component, Fragment } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { toast } from 'react-toastify';

import * as Yup from "yup";
import axios from "axios";

const AccountSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email")
      .required("Required"),
      nom: Yup.string()
      .required("Required"),
      prenom: Yup.string()
      .required("Required")
});


class AccountForm extends Component {
    render() {
      const {nom, prenom, email, societe, rue, cp, localite, pays, tel} = this.props.userinfos;
      return (
        <Fragment>
        <Formik
        initialValues={{ nom:nom, prenom:prenom, email:email, societe:societe, rue:rue, cp:cp, localite:localite, pays:pays, tel:tel }}
        validationSchema={AccountSchema}
        onSubmit={(values, { setSubmitting }) => {
              axios
                .post("auth/infos", {
                  email: values.email,
                  nom: values.nom,
                  prenom: values.prenom,
                  societe: values.societe,
                  rue: values.rue,
                  cp: values.cp,
                  localite: values.localite,
                  pays: values.pays,
                  tel: values.tel
                })
                .then(res => {
                  if(res.data.error){
                    toast.error(res.data.error);
                  }
                  if(res.data.success){
                    toast.success(res.data.success);
                    this.props.buttonClick();
                  }
                  setSubmitting(false);
                }).catch(error => {  toast.error(error.message);setSubmitting(false); });
        }}
      >
        {({ isSubmitting }) => (
          <Form style={{ marginBottom: "80px" }}>
            <label htmlFor="nom">Family name</label>
            <Field type="text" name="nom" />
            <ErrorMessage name="nom" component="div" />

            <label htmlFor="prenom">First name</label>
            <Field type="text" name="prenom" />
            <ErrorMessage name="prenom" component="div" />

            <label htmlFor="email">Email adress</label>
            <Field type="email" name="email" />
            <ErrorMessage name="email" component="div" />

            <label htmlFor="societe">Company</label>
            <Field type="text" name="societe" />
            <ErrorMessage name="societe" className="error" component="div" />
            <label htmlFor="rue">Street</label>
            <Field type="text" name="rue" />
            <ErrorMessage name="rue" className="error" component="div" />
            <label htmlFor="cp">Zip code</label>
            <Field type="text" name="cp" />
            <ErrorMessage name="cp" className="error" component="div" />
            <label htmlFor="localite">City</label>
            <Field type="text" name="localite" />
            <ErrorMessage name="localite" className="error" component="div" />
            <label htmlFor="pays">Country</label>
            <Field type="text" name="pays" />
            <ErrorMessage name="pays" className="error" component="div" />
            <label htmlFor="tel">Phone</label>
            <Field type="text" name="tel" />
            <ErrorMessage name="tel" className="error" component="div" />
            
            <button type="submit" disabled={isSubmitting}>
              Change Information
            </button>
          </Form>
        )}
    </Formik>
    </Fragment>
      );
    }
}


export default AccountForm;